import graphqlClient from "@/GQLClient";
import {
  GetRepeatOccurrencesDocument,
  type RRuleSetInput,
} from "@/graphql/generated-types";
import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";
import { formatDateTimeWithTimezone } from "@/stories/utils/dates";

export type OccurrencesResult = {
  status: "success" | "infinite" | "error";
  data: string[];
};

type GetOccurrencesProps = {
  rset: RRuleSetInput;
  dateFrom?: Date;
  dateTo?: Date;
};

const getOccurrences = async (
  props: GetOccurrencesProps,
): Promise<OccurrencesResult> => {
  const { rset, dateFrom, dateTo } = props;

  if (
    rset.rule.INTERVAL === 0 ||
    rset.rule.COUNT === 0 ||
    rset.rule.INTERVAL?.toString().trim() === "" ||
    rset.rule.COUNT?.toString().trim() === ""
  ) {
    return {
      status: "error",
      data: [],
    };
  }

  // This is an infinite rrule. We can not create dates
  if (rset.rule.COUNT === undefined && rset.rule.UNTIL === undefined) {
    return {
      status: "infinite",
      data: [],
    };
  }

  const response = await graphqlClient.query({
    query: GetRepeatOccurrencesDocument,
    variables: {
      rset,
      dateFrom: dateFrom ? formatDateTimeWithTimezone(dateFrom) : undefined,
      dateTo: dateTo ? formatDateTimeWithTimezone(dateTo) : undefined,
    },
    fetchPolicy: "cache-first", // Cache results by variables
  });

  if (response.data.repeat?.getOccurrences) {
    return {
      status: "success",
      data: response.data.repeat?.getOccurrences,
    };
  }

  throw new SentryGraphQLError();
};

export default {
  getOccurrences,
};
